module.exports = "https://web-assets.ifttt.com/packs/media/shared/apple-touch-icon-180x180-precomposed-8f2d2244.png";